export var SwingingStatusContent;
(function (SwingingStatusContent) {
    SwingingStatusContent["PortBow"] = "over port bow";
    SwingingStatusContent["StarboardBow"] = "over starboard bow";
    SwingingStatusContent["Completed"] = "completed";
})(SwingingStatusContent || (SwingingStatusContent = {}));
//# sourceMappingURL=SwingingStatusContent.js.map